/** MUI 调色板配置 — 对齐操作人员移动端视觉精修稿（docs/操作人员移动端），见 tokens.ts */
import type { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  primary: {
    main: '#1F6FE5',
    dark: '#1657C0',
    light: '#EAF2FE',
    contrastText: '#FFFFFF',
    50: '#EAF2FE',
    100: '#CFE1FD',
    200: '#A6C8FA',
    300: '#78ABF5',
    400: '#4C8EEE',
    500: '#1F6FE5',
    600: '#1F6FE5',
    700: '#1657C0',
    800: '#1657C0',
    900: '#0F4AA8',
  },
  secondary: {
    main: '#18A06B',
    light: '#E7F6EE',
    dark: '#0E7A50',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#E5484D',
    light: '#FDECEC',
    dark: '#C4343A',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#F0A020',
    light: '#FEF3E3',
    dark: '#B26A00',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#18A06B',
    light: '#E7F6EE',
    dark: '#0E7A50',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#00ACC1',
    light: '#E0F7FA',
    dark: '#00838F',
    contrastText: '#FFFFFF',
  },
  grey: {
    50: '#F6F9FD',
    100: '#F2F5FA',
    200: '#E8EAED',
    300: '#DADCE0',
    400: '#BDC1C6',
    500: '#9E9E9E',
    600: '#80868B',
    700: '#616161',
    800: '#3C4043',
    900: '#212121',
  },
  background: {
    default: '#F4F8FE',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#14202E',
    secondary: '#5A6573',
    disabled: '#9AA4B2',
  },
  divider: '#EBEFF5',
  /** 青绿色强调色（原型 --accent #00D4AA），用于电子签收、扫描框等 */
  accent: {
    main: '#00D4AA',
    light: '#E0F7F4',
    dark: '#00A884',
    contrastText: '#ffffff',
  },
};

/**
 * 扩展 MUI Palette，使 `theme.palette.accent` 在 TS 中可用。
 * 仅新增字段，不影响 admin 端或其他 palette 键。
 */
declare module '@mui/material/styles' {
  interface Palette {
    accent: { main: string; light: string; dark: string; contrastText: string };
  }
  interface PaletteOptions {
    accent?: { main: string; light: string; dark: string; contrastText: string };
  }
}
